<template>
  <Container>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Email Confirmation</h5>
                  <p>Confirmation Link Sent!</p>
                </div>
              </div>

              <div class="col-5 align-self-end">
                <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
              </div>
            </div>
          </div>

          <div class="card-body pt-0">
            <div>
              <router-link tag="a" to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="@/assets/images/logo.svg" alt height="34" />
                  </span>
                </div>
              </router-link>
            </div>
            <p>
              An email has been sent to <b>{{ $route.params.email }}</b
              >. Please click the confirmation link to complete your sign up.
            </p>
          </div>
        </div>

        <div class="mt-5 text-center">
          <p>
            © {{ new Date().getFullYear() }} Skote. Crafted with <i class="mdi mdi-heart text-danger"></i> by
            Themesbrand
          </p>
        </div>
      </div>
    </div>
  </Container>
</template>

<script>
import Container from "../layouts/auth";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Email Confirmation",
    meta: [{ name: "description", content: appConfig.description }],
  },

  components: {
    Container,
  },
};
</script>
